import { render, staticRenderFns } from "./2_product_center_details_6.vue?vue&type=template&id=2f75aaa2&scoped=true&"
import script from "./2_product_center_details_6.vue?vue&type=script&lang=js&"
export * from "./2_product_center_details_6.vue?vue&type=script&lang=js&"
import style0 from "./2_product_center_details_6.vue?vue&type=style&index=0&id=2f75aaa2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f75aaa2",
  null
  
)

export default component.exports